import TSearch from '../templates/search';

function Search() {
  return <TSearch></TSearch>;
}

export default Search;
